import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS
const GREY = {
	0: '#FFFFFF',
	100: '#F2F2F7',
	200: '#E5E5EA',
	300: '#D1D1D6',
	400: '#C7C7CC',
	500: '#AEAEB2',
	600: '#8E8E93',
	700: '#737378',
	800: '#414144',
	900: '#19191A',
};

const PRIMARY = {
	lighter: '#EFF6FF',
	light: '#99CCFF',
	main: '#0066CC',
	dark: '#00339C',
	darker: '#00265E',
	contrastText: '#fff',
};

const SECONDARY = {
	lighter: '#FFF3E7',
	light: '#FFC790',
	main: '#FF9015',
	dark: '#C75507',
	darker: '#7F390F',
	contrastText: '#fff',
};

const INFO = {
	lighter: '#E5E6FA',
	light: '#B4B4ED',
	main: '#8A7BD9',
	dark: '#6951B1',
	darker: '#221C35',
	contrastText: '#fff',
};

const SUCCESS = {
	lighter: '#D1FAE5',
	light: '#6EE7B7',
	main: '#10B981',
	dark: '#047857',
	darker: '#064E3B',
	contrastText: GREY[900],
};

const WARNING = {
	lighter: '#FEF9C3',
	light: '#F9E887',
	main: '#FACC15',
	dark: '#A16207',
	darker: '#713F12',
	contrastText: GREY[900],
};

const ERROR = {
	lighter: '#FFE3E3',
	light: '#FFA2A8',
	main: '#F83B50',
	dark: '#C20E2F',
	darker: '#700F2B',
	contrastText: '#fff',
};

const palette = {
	common: { black: '#000', white: '#fff' },
	primary: PRIMARY,
	secondary: SECONDARY,
	info: INFO,
	success: SUCCESS,
	warning: WARNING,
	error: ERROR,
	grey: GREY,
	brand: {
		main: '#ff9015',
		light: '#ffb547',
		dark: '#c56000',
		contrastText: '#ffffff',
	},
	divider: alpha(GREY[500], 0.24),
	text: {
		primary: GREY[800],
		secondary: GREY[600],
		disabled: GREY[500],
	},
	background: {
		paper: '#fff',
		default: GREY[100],
		neutral: GREY[200],
	},
	action: {
		active: GREY[600],
		hover: alpha(GREY[500], 0.08),
		selected: alpha(GREY[500], 0.16),
		disabled: alpha(GREY[500], 0.8),
		disabledBackground: alpha(GREY[500], 0.24),
		focus: alpha(GREY[500], 0.24),
		hoverOpacity: 0.08,
		disabledOpacity: 0.48,
	},
};

export default palette;
